import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import {
    PERFIL_ADMIN, PERFIL_ADMIN_EMPRESA,
    PERFIL_FINANCEIRO_AGENCIA,
    PERFIL_MOTORISTA_EMPRESA,
    PERFIL_VENDEDOR_AGENCIA,
    PERFIL_VENDEDOR_EMPRESA,
} from '../../../security/securityContext';
import selecionarPerfis from '../../../actions/perfil/selecionarPerfis';
import selecionarUsuario from '../../../actions/usuario/selecionarUsuario';
import { buscarUsuarios, buscarUsuariosSistema } from '../../../actions/usuario/buscarUsuarios';
import { buscarMotorista } from '../../../actions/motorista/motoristaActions';
import buscarDescontosUsuarioRota from '../../../actions/desconto/buscarDescontosUsuarioRota';
import buscarUsuariosEmpresaAgencia from '../../../actions/usuario-empresa-agencia/buscarUsuariosEmpresaAgencia';
import ativarUsuarioEmpresa from '../../../actions/usuario/ativarUsuarioEmpresa';
import desativarUsuarioEmpresa from '../../../actions/usuario/desativarUsuarioEmpresa';
import { estados } from '../../../util/constantsUtil';
import { showSuccessMsg } from '../../../util/messagesUtil';
import Autorizacao from '../../../security/Autorizacao';
import ReactTooltip from 'react-tooltip';
import iconAudoria from  '../../../img/auditoria.png';
import buscarUltimosHistoricosUsuario from '../../../actions/usuario/buscarUltimosHistoricosUsuario';


const ModalConfirmacaoInativacaoUsuarioEmpresa = ({ inativar, atualizarCheckBox }) => (
    <div className="modal fade" id="ModalConfirmacaoInativacaoConfiguracao" tabIndex="-1" role="dialog"
        aria-labelledby="ModalConfirmacaoInativacaoConfiguracao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Confirmar inativação do usuário? </p>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-outline-secondary"
                        data-dismiss="modal" onClick={() => atualizarCheckBox()}>Cancelar
                    </button>
                    <button type="button" className="btn btn-azul float-left" data-dismiss="modal"
                        onClick={() => inativar()}>Desativar
                    </button>
                </div>
            </div>
        </div>
    </div>);

export class Usuario extends React.Component {
    selecionarUsuario(usuario) {
        const perfis = [];
        this.props.selecionarUsuario(this.props.usuario);
        usuario.rolesName.map(role => perfis.push({
            label: role.descricao,
            value: role.valor
        }));
        this.props.selecionarPerfis(perfis);
        this.props.preencherModalEdicao(usuario);
    }

    selecionarMotorista() {
        this.props.buscarMotorista(this.props.usuario.usuarioEmpresaId, this.props.empresaSelecionada.id)
            .then(resp => {
                if (resp.payload) {
                    const estado = estados.filter(f => f.uf === resp.payload.uf)[0];
                    this.props.changeFieldValue('formCadastrarMotorista',
                        'numeroRegistroCNH', resp.payload.numeroRegistroCNH);
                    this.props.changeFieldValue('formCadastrarMotorista',
                        'categoriaCNH', { value: resp.payload.categoriaCNH, label: resp.payload.categoriaCNH });
                    this.props.changeFieldValue('formCadastrarMotorista',
                        'docIdentidadeEmissor', resp.payload.docIdentidadeEmissor);
                    this.props.changeFieldValue('formCadastrarMotorista',
                        'estadoEmissao', { label: `${estado.nome}-${estado.uf}`, value: estado.uf });
                    this.props.changeFieldValue('formCadastrarMotorista',
                        'validadeCNH', resp.payload.validadeCNH);
                    this.props.changeFieldValue('formCadastrarMotorista',
                        'validadeRegistroANTT', resp.payload.validadeRegistroANTT);
                    this.props.changeFieldValue('formCadastrarMotorista',
                        'numeroRegistroANTT', resp.payload.numeroRegistroANTT);
                    this.props.changeFieldValue('formCadastrarMotorista',
                        'idMotorista', resp.payload.id);

                }

            })

    }

    carregarDadosModalAlteracao() {        
        const vendedor = this.props.usuario.rolesName
            .filter(f => f.valor === 'ROLE_VENDEDOR_AGENCIA' || f.valor === 'ROLE_VENDEDOR_EMPRESA' || f.valor === 'ROLE_OPERADOR_REMARCACAO' || f.valor === 'ROLE_ADMIN_EMPRESA');
        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo !== 'TCB' && this.props.empresaSelecionada.grupo !== 'CIDAO') {
                if (this.props.usuario.comissoes
                    && this.props.usuario.comissoes.length) {
                    
                    if (this.props.usuario.comissoes.find(it => it.tipoServico == 'RESERVA')) {
                        this.props.changeFieldValue('formularioAlterarUsuario',
                            'comissaoUsuario', this.props.usuario.comissoes.find(it => it.tipoServico == 'RESERVA').porcentagem);
                    }
                    if (this.props.usuario.comissoes.find(it => it.tipoServico == 'ENCOMENDA')) {
                        this.props.changeFieldValue('formularioAlterarUsuario',
                            'comissaoEncomenda', this.props.usuario.comissoes.find(it => it.tipoServico == 'ENCOMENDA').porcentagem);
                    }
                    if (this.props.usuario.comissoes.find(it => it.tipoServico == 'EXCESSO_BAGAGEM')) {
                        this.props.changeFieldValue('formularioAlterarUsuario',
                            'comissaoExcessoBagagem', this.props.usuario.comissoes.find(it => it.tipoServico == 'EXCESSO_BAGAGEM').porcentagem);
                    }
                    if (this.props.usuario.comissoes.find(it => it.tipoServico == 'IMPRESSAO_BILHETE')) {
                        this.props.changeFieldValue('formularioAlterarUsuario',
                            'comissaoImpressaoBilhete', this.props.usuario.comissoes.find(it => it.tipoServico == 'IMPRESSAO_BILHETE').porcentagem);
                    }

                }

            }

        }
    }

    atualizarCheckBox() {
        document.getElementById(this.props.usuarioSelecionado.id).checked = true;
    }

    exibirInativacao() {
        if (this.props.usuario.ativo) {
            return <input data-toggle="modal"
                id={this.props.usuario.usuarioEmpresaId}
                data-target="#ModalConfirmacaoInativacaoConfiguracao"
                className="checkbox-custom"
                type="checkbox"
                checked={this.props.usuario.ativo}                
                onChange={() => this.props.selecionarUsuario(this.props.usuario)} />
        }

        return <input className="checkbox-custom"
            type="checkbox"
            id={this.props.usuario.usuarioEmpresaId}
            checked={this.props.usuario.ativo}            
            onChange={() => this.ativar()} />
    }

    ativar() {
        this.props.ativarUsuarioEmpresa(this.props.usuario.id, this.props.usuario.idEmpresa).then(() => {
            showSuccessMsg('Usuário ativado com sucesso!');
            if (this.props.usuarioSistema) {
                this.props.buscarUsuariosSistema(this.props.usuario.idEmpresa, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
            } else {
                this.props.buscarUsuarios(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
            }

        })
    }

    exibirStatus() {
        if (this.props.usuario.ativo) {
            return (<span className="txt-ativo">Ativo</span>);
        }
        return (<span className="txt-inativo">Inativo</span>);
    }

    exibirIconeObservacao() {
        const usuarioSistema = this.props.usuario.usuarioSistema;
        if (usuarioSistema) {
            return (
                <span className="align-self-center tooltip-info">
                    <a data-tip data-for="anotacao-usuario">
                        <i className="material-icons ajuda-icon" style={{ color: '#000' }}>&#xe147;</i>
                    </a>
                    <div className="tooltip-ut">
                        <ReactTooltip className="tooltip-ut" id="anotacao-usuario" type="dark" effect="solid">
                            <div className="row">
                                <p key="info-usuario">Usuário Sistema: Sim</p>
                            </div>
                        </ReactTooltip>
                    </div>
                </span>
            );
        }

        return null;
    }

    iconeBloqueioDesbloqueio() {
        if (this.props.usuario.bloqueado) {
            return <i className="material-icons nav-icon">&#xe899;</i>
        }
        return <i className="material-icons nav-icon">&#xe898;</i>
    }

    inativar() {
        this.props.desativarUsuarioEmpresa(this.props.usuarioSelecionado.id, this.props.usuarioSelecionado.idEmpresa).then(() => {
            showSuccessMsg('Usuário desativado com sucesso!');
            if (this.props.usuarioSistema) {
                this.props.buscarUsuariosSistema(this.props.usuarioSelecionado.idEmpresa, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
            } else {
                this.props.buscarUsuarios(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
            }
        });
    }

    render() {
        const temPerfilAgencia = this.props.usuario.rolesName.filter(it => [PERFIL_VENDEDOR_AGENCIA, PERFIL_FINANCEIRO_AGENCIA, PERFIL_VENDEDOR_EMPRESA].includes(it.identificacao)).length;
        const temPerfilMotorista = this.props.usuario.rolesName.filter(it => [PERFIL_MOTORISTA_EMPRESA].includes(it.identificacao)).length;
        return (
            <React.Fragment>
                <div className="geral">
                    <div className="resumo">
                        <div className="row">
                            <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1">
                                <span className="titulo-mobile">Número:&nbsp;</span>{this.props.usuario.id}
                            </div>
                            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                <span className="titulo-mobile">Nome:&nbsp;</span>{this.props.usuario.nome}
                            </div>
                            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2"
                                style={{ overflowWrap: 'break-word' }}>
                                <span className="titulo-mobile">E-mail:&nbsp;</span>
                                {this.props.usuario.email}
                                <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                                    {this.exibirIconeObservacao()}
                                </Autorizacao>
                            </div>
                            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                <span className="titulo-mobile">Empresa:&nbsp;</span>{this.props.usuario.nomeEmpresa}
                            </div>
                            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                <span className="titulo-mobile">Telefone:&nbsp;</span>{this.props.usuario.telefone}
                            </div>
                            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                                <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1">
                                    <span
                                        className="titulo-mobile">Data de criação:&nbsp;</span>{this.props.usuario.dataCriacao}
                                </div>
                            </Autorizacao>
                            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                <div className="acoes">
                                    <div className="botoes">
                                        <button type="button" className="btn btn-editar ml-2"
                                            data-toggle="modal"
                                            title="Editar"
                                            data-target='#modalAlterarUsuario'
                                            onClick={() => {
                                                this.selecionarUsuario(this.props.usuario)
                                                this.carregarDadosModalAlteracao();
                                            }}>
                                            <i className="material-icons nav-icon">&#xe150;</i>
                                        </button>
                                        <button type="button" className="btn btn-excluir"
                                            data-toggle="modal"
                                            title={`${this.props.usuario.bloqueado ? 'Desbloquear usuário' : 'Bloquear usuário'}`}
                                            data-target="#modalConfirmacaoBloqueioDesbloqueio"
                                            onClick={() => {
                                                this.props.selecionarUsuario(this.props.usuario);
                                            }}>
                                            {this.iconeBloqueioDesbloqueio()}
                                        </button>
                                        <button type="button" className="btn btn-excluir"
                                            data-toggle="modal"
                                            title="Cadastrar desconto"
                                            data-target="#modalCadastrarUsuarioDescontoRota"
                                            onClick={() => {
                                                this.props.selecionarUsuario(this.props.usuario);
                                                this.props.buscarDescontosUsuarioRota(this.props.empresaSelecionada.id, this.props.usuario.id)
                                            }}>
                                            <i className="material-icons nav-icon">&#xe227;</i>
                                        </button>
                                        {temPerfilAgencia ?
                                            <button type="button" className="btn btn-excluir"
                                                data-toggle="modal"
                                                title="Relacionar agência"
                                                data-target="#modalRelacionarAgenciaUsuario"
                                                onClick={() => {
                                                    this.props.selecionarUsuario(this.props.usuario);
                                                    this.props.buscarUsuariosEmpresaAgencia(this.props.empresaSelecionada.id, this.props.usuario.usuarioEmpresaId)
                                                }}>
                                                <i className="material-icons nav-icon">&#xe8f9;</i>
                                            </button> : ''}

                                        {temPerfilMotorista ?
                                            <button type="button" className="btn btn-excluir"
                                                data-toggle="modal"
                                                title="Informar dados motorista"
                                                data-target="#modalCadastrarMotorista"
                                                onClick={() => {
                                                    this.props.selecionarUsuario(this.props.usuario);
                                                    this.selecionarMotorista()

                                                }}>
                                                <i className="material-icons nav-icon">&#xe637;</i>
                                            </button> : ''}

                                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN, PERFIL_ADMIN_EMPRESA]}>
                                            <button type="button" className="btn ml-2"
                                                    data-toggle="modal"
                                                    title='Buscar últimos Históricos Usuário'
                                                    data-target="#modalHistoricoUsuario"
                                                    onClick={() => {
                                                        this.props.selecionarUsuario(this.props.usuario);
                                                        this.props.buscarUltimosHistoricosUsuario(this.props.usuario.id, this.props.empresaSelecionada.id)
                                                    }}>
                                                <img src={iconAudoria} alt="Históricos Usuario"/>
                                            </button>
                                        </Autorizacao>
                                    </div>
                                    <div className="botoes">
                                        <span className="titulo-mobile tm-status">Status:&nbsp;</span>
                                        <div className="custom-btn-status ativo">
                                            {this.exibirInativacao()}
                                            <label htmlFor={this.props.usuario.usuarioEmpresaId}
                                                   className="checkbox-custom-label"/>
                                            {this.exibirStatus()}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <ModalConfirmacaoInativacaoUsuarioEmpresa inativar={this.inativar.bind(this)}
                    atualizarCheckBox={this.atualizarCheckBox.bind(this)} />
            </React.Fragment>
        )
    }
}

export function mapStateToProps(state) {
    return {
        perfisSelecionados: state.perfisSelecionados,
        usuarioSelecionado: state.usuarioSelecionado,
        paginaAtual: state.paginaAtualUsuario,
        registrosPorPagina: state.registrosPorPaginaUsuario,
        empresaSelecionada: state.empresaSelecionada,
        filtrosAdicionados: state.filtrosAdicionadosUsuarios
    }
}

export default connect(mapStateToProps, {
    changeFieldValue,
    selecionarPerfis,
    selecionarUsuario,
    ativarUsuarioEmpresa,
    desativarUsuarioEmpresa,
    buscarUsuarios,
    buscarUsuariosSistema,
    buscarDescontosUsuarioRota,
    buscarUsuariosEmpresaAgencia,
    buscarMotorista,
    buscarUltimosHistoricosUsuario
})(reduxForm({
    form: 'formularioAlterarUsuario'
})(Usuario))
